import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { ReportIssueService } from '../../services/report-issue.service';
import { SnackBarService } from '../../services/snack-bar.service';

@Component({
  selector: 'app-report-issue-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatIconModule, TranslatePipe],
  templateUrl: './report-issue-dialog.component.html',
  styleUrl: './report-issue-dialog.component.scss',
})
export class ReportIssueDialogComponent {
  summary = '';
  description = '';
  readonly submitting = signal(false);
  readonly submitted = signal(false);

  constructor(
    private dialogRef: MatDialogRef<ReportIssueDialogComponent>,
    private reportIssueService: ReportIssueService,
    private snackBar: SnackBarService
  ) {}

  get isValid(): boolean {
    return this.summary.trim().length > 3 && this.description.trim().length > 10;
  }

  get validationHint(): string {
    if (!this.summary.trim()) {
      return 'Add a short summary to continue';
    }
    if (this.summary.trim().length <= 3) {
      return 'Summary is too short';
    }
    if (!this.description.trim()) {
      return 'Describe the problem to continue';
    }
    if (this.description.trim().length <= 10) {
      return 'Description is too short';
    }
    return '';
  }

  async submit(): Promise<void> {
    if (!this.isValid || this.submitting()) return;

    this.submitting.set(true);
    try {
      await this.reportIssueService.report({
        summary: this.summary.trim(),
        description: this.description.trim(),
      });
      this.submitted.set(true);
    } catch {
      this.snackBar.openSnackBar('Could not submit report. Please try again.');
    } finally {
      this.submitting.set(false);
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
